module.exports = __webpack_public_path__ + "static/img/1.211faf09.png";